import type { CourseDraftLocalizedSectionsItem } from './courseDraftLocalizedSectionsItem';

/**
 * 언어별 섹션 정보 매핑
 * @nullable
 */
export type CourseDraftLocalizedSections = {[key: string]: CourseDraftLocalizedSectionsItem[]} | null;
